import React from 'react'
import { RiskEconomyCardGraph } from './RiskEconomyCardGraph'
import { FinancialYear, FinancialYearDashboardGraphDTO } from '../../../api/schemas/schema'
import { DashboardInfoCard } from '../DashboardInfoCard'
import { IListState } from '../../../interfaces/IListState'
import { t } from '../../../i18n/i18n'
import { Text } from '@fluentui/react-components'


type RiskEconomyCardProps = {
   setRiskEconomyState: React.Dispatch<React.SetStateAction<IListState<FinancialYear>>>
   latestFinancialYears: FinancialYearDashboardGraphDTO[]
}

export const RiskEconomyCard = ({ setRiskEconomyState, latestFinancialYears }: RiskEconomyCardProps) => {
   return (
      <>
         {latestFinancialYears?.length === 0 ? (
            <DashboardInfoCard
               title={t('CreateNewFinancialYear')}
               description={t('CreateNewFinancialYearDescription')}
               buttonText={t('CreateFinancialYear')}
               onClick={() => setRiskEconomyState((prev) => ({ ...prev, open: true }))}
            />
         ) : (
            <>
               <Text size={600} weight="semibold">
                  {t('RiskEconomy')}
               </Text>
               <RiskEconomyCardGraph latestFinancialYears={latestFinancialYears} />
            </>
         )}
      </>
   )
}
